import { categories } from '@/mocks/categories';

export default function CategoryGridSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs bg-primary-100 text-primary-700 rounded-full mb-3 whitespace-nowrap">
            内容分类
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            六大核心内容领域
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            覆盖影视、资讯、娱乐、科技、文化、商业全领域，满足不同用户的内容消费需求
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center p-6 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-100 transition-colors mb-4">
                <i className={`${category.icon} text-xl text-foreground-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors mb-1 whitespace-nowrap">
                {category.name}
              </h3>
              <p className="text-xs text-foreground-400 text-center leading-relaxed">
                {category.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}